<script>
import PartNumbers from '@/components/PartNumbers.vue'

export default {
    name: 'ChildComp',
    components: {
        PartNumbers,
    },
    props: {
        apiBase: String,
        config: String,
        parts: Array,
        filters: Array,
    },
    data: () => ({
        loading: false,
    }),
    methods: {
        stringToRegExp(pattern, { caseInsensitive = false } = {}) {
            if (pattern == null) pattern = "";               // null/undefined safety
            const escaped = String(pattern)
                .replace(/[.+^${}()|[\]\\]/g, "\\$&")          // escape regex metachars
                .replace(/\*/g, ".*")                          // convert *
                .replace(/\?/g, ".");                          // convert ?
            return new RegExp(`^${escaped}$`, caseInsensitive ? "i" : "");
        }
    },
    computed: {
        matching: function () {
            // gonna have to flip the filter logic on this
            // when a filter is not in the array we want a wildcard in its place
            // config sections are all 4 characters each + 7 char base model
            let wildcardString = "* - ???? - ???? - ????"
            let wildcardStringLP = "* ???? ?????"
            var base
            var matchingArray
            var matchingString
            var configParts
            if (this.config.startsWith("L")) {
                configParts = wildcardStringLP.split(" ")
                base = configParts[0]
                let temp = configParts[1] + configParts[2]
                matchingArray = [base, ...temp.split('')]
                console.log(configParts)
                for (const filter of this.filters) {
                    if (filter.index === 0) {
                        matchingArray[filter.index] = filter.value
                    } else {
                        matchingArray[filter.index] = filter.value
                    }
                }

                const [first, ...rest] = matchingArray

                const grouping = []

                
                grouping.push(rest.slice(0, 4).join(''))
                grouping.push(rest.slice(4,rest.length).join(''))
                

                matchingString = [first, ...grouping].join(" ")
            } else {
                configParts = wildcardString.split(" - ")
                base = configParts[0]
                let temp = configParts[1] + configParts[2] + configParts[3]
                matchingArray = [base, ...temp.split('')]

                for (const filter of this.filters) {
                    if (filter.index === 0) {
                        matchingArray[filter.index] = filter.value
                    } else {
                        matchingArray[filter.index] = filter.value
                    }
                }

                const [first, ...rest] = matchingArray

                const grouping = []

                for (let i = 0; i < rest.length; i += 4) {
                    grouping.push(rest.slice(i, i + 4).join(''))
                }

                matchingString = [first, ...grouping].join(" - ")
            }



            const re = this.stringToRegExp(matchingString)

            const filteredParts = this.parts.filter(({ config }) => re.test(String(config)))
            console.log("matching results\n", this.config, matchingString, filteredParts)

            const uniqueFilteredParts = filteredParts.filter((obj, index, self) =>
                index === self.findIndex((t) => t.part === obj.part)
            );


            return uniqueFilteredParts
        },
        haveParts: function () { return this.matching.length > 0 },
        msg: function () {
            switch (true) {
                case this.loading: return "Loading part numbers..."
                case this.parts.length === 0: return "An error occurred while loading the configurations."
                case !this.haveParts: return "No drawings available for this configuration."
                default: return `Part numbers:`
            }
        },
    },
}
</script>

<template>
    <div>
        <v-row class="d-flex justify-center">
            <h2>{{ msg }}</h2>
        </v-row>
        <v-row v-if="haveParts">
            <PartNumbers :parts="matching" :api-base="apiBase" />
        </v-row>
    </div>
</template>
